// Rebuy Smart Cart hooks: keep the header count in sync and refresh delivery estimates.
function onRebuyCartEvent(event) {
  setCartCount(event);
  updateShippingDates();
}

document.addEventListener('rebuy:cart.change', onRebuyCartEvent);
document.addEventListener('rebuy:cart.ready', onRebuyCartEvent);

async function setCartCount(event) {
  const cartCounts = document.querySelectorAll('[js-cart-count]');
  for (const cartCount of cartCounts) {
    cartCount.textContent = event.detail.cart.cart.item_count;
  }

  const cartCountsWithText = document.querySelectorAll('[js-cart-count-with-text]');
  for (const cartCountWithText of cartCountsWithText) {
    cartCountWithText.textContent =
      event.detail.cart.cart.item_count + ' item' + (event.detail.cart.cart.item_count == 1 ? '' : 's');
  }
}

// Detect if current market is UK
function isUKMarket() {
  // Check Shopify's country/locale data
  if (typeof Shopify !== 'undefined') {
    if (Shopify.country === 'GB' || Shopify.country === 'UK') return true;
    if (Shopify.Checkout?.locale?.includes('en-GB')) return true;
  }

  // Fallback: check URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('country') === 'GB' || urlParams.get('country') === 'UK') return true;

  return false;
}

// Calculate shipping dates with UK market adjustment
function calculateShippingDates(daysUntilShip) {
  const now = new Date();
  const msPerDay = 24 * 60 * 60 * 1000;

  // Calculate ship date
  const shipDate = new Date(now.getTime() + daysUntilShip * msPerDay);

  // Calculate min and max dates (ship date + 4 days to ship date + 10 days)
  let shipDateMin = new Date(shipDate.getTime() + 4 * msPerDay);
  let shipDateMax = new Date(shipDate.getTime() + 10 * msPerDay);

  // Add 10 days for UK market
  if (isUKMarket()) {
    shipDateMin = new Date(shipDateMin.getTime() + 10 * msPerDay);
    shipDateMax = new Date(shipDateMax.getTime() + 10 * msPerDay);
  }

  // Format dates (e.g., "November 28, 2025")
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  const minFormatted = shipDateMin.toLocaleDateString('en-US', options);
  const maxFormatted = shipDateMax.toLocaleDateString('en-US', options);

  return `${minFormatted} and ${maxFormatted}`;
}

// Fetch live days_until_ship values for the current cart from Shopify.
// Rebuy's product catalog caches variant metafields and can serve stale
// values, so the theme section is the source of truth here.
async function fetchLiveShipDays() {
  try {
    const response = await fetch(`/?section_id=nb-cart-eta`);
    if (!response.ok) {
      console.error('Failed to fetch live ship days:', response.status);
      return null;
    }

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const dataElement = doc.querySelector('[js-cart-eta]');
    if (!dataElement) {
      console.error('Cart ETA element not found in response');
      return null;
    }

    const lines = JSON.parse(dataElement.textContent).lines;
    if (!Array.isArray(lines)) return null;

    const daysByVariant = {};
    const daysByHandle = {};
    for (const line of lines) {
      daysByVariant[line.variant] = line.days;
      // A handle only resolves a lead time when all its cart lines agree.
      if (!(line.handle in daysByHandle)) daysByHandle[line.handle] = line.days;
      else if (daysByHandle[line.handle] !== line.days) daysByHandle[line.handle] = null;
    }
    return { daysByVariant, daysByHandle };
  } catch (error) {
    console.error('Error fetching live ship days:', error);
    return null;
  }
}

// Rebuy item elements link to /products/<handle>?variant=<id> — recover both
// so the item can be matched against the live cart data.
function getItemEtaKeys(itemElement) {
  const link = itemElement.querySelector('a[href*="/products/"]');
  const href = (link && link.getAttribute('href')) || '';
  const variantMatch = href.match(/[?&]variant=(\d+)/);
  const handleMatch = href.match(/\/products\/([^/?#]+)/);
  return { variantId: variantMatch && variantMatch[1], handle: handleMatch && handleMatch[1] };
}

// Update shipping dates in Rebuy cart
async function updateShippingDates() {
  const liveDays = await fetchLiveShipDays();

  // Query after the fetch so items rendered in the meantime are included.
  const cartItems = document.querySelectorAll('[data-days-until-ship]');

  cartItems.forEach((item) => {
    let daysUntilShip = NaN;

    if (liveDays) {
      const { variantId, handle } = getItemEtaKeys(item);
      if (variantId && liveDays.daysByVariant[variantId] != null) {
        daysUntilShip = parseInt(liveDays.daysByVariant[variantId], 10);
      } else if (handle && liveDays.daysByHandle[handle] != null) {
        daysUntilShip = parseInt(liveDays.daysByHandle[handle], 10);
      }
    }

    // Fall back to Rebuy's cached value if the item couldn't be matched.
    if (isNaN(daysUntilShip)) {
      daysUntilShip = parseInt(item.getAttribute('data-days-until-ship'), 10);
    }
    if (isNaN(daysUntilShip)) return;

    const dateElement = item.querySelector('.nb-cart-item-ship-date');
    if (!dateElement) return;

    const dateRange = calculateShippingDates(daysUntilShip);
    dateElement.textContent = `Estimated delivery between ${dateRange}`;
  });
}
